//include 9
//console.log("WTF");
jQuery(function () {
    var container = $(".anreiseplanner-box");
    if (container.length == 0)
        return;

    var privateFunctions = {
        getDirections(id, type, transport, address, e, $this, target) {
            var argts = {
                id: id,
                type: type,
                transport: transport
            };
            var maplink = 'directions.default';
            if(!!target){
                argts.target = target;
                maplink = 'directions.defaulttarget';
                if(!!address){
                    argts.address = address;
                    maplink = 'directions.addresses';
                }
            }
            else{
                if(!!address){
                    argts.address = address;
                    maplink = 'directions.address';
                }
            }
            if (!window.pixelpoint.isMobile.any()) {
                e.preventDefault();
                window.pixelpoint.map.open(maplink, argts);
            } else {
                var link = window.pixelpoint.map.getLink(maplink, argts);
                if (!!link) {
                    $this.attr("href", link);
                }
            }
        }
    };

    container.each(function () {
        var $this = $(this);
        var id = $this.data('id');
        var type = $this.data('type') || 'poi';
        if (!id)
            return;
        var input = $this.find("input.address-input");
        var targetInput = $this.find('input.target-input');
        var targetAddress = targetInput.length > 0 ? targetInput.val() : null;
        $this.on("click", ".brandenbutton", function (e) {
            $(this).attr("target", "_blank");
            var address = input.val();
            var transport = $this.find('input[name="transportation"]:checked').val() || 'car';
            privateFunctions.getDirections(id, type, transport, address, e, $(this), targetAddress);
        });
    });


});